const ALPHABET = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

// Largest multiple of the alphabet size that fits in a byte, so every character is equally likely.
const UNBIASED_LIMIT = 256 - (256 % ALPHABET.length);

export const generatePassword = (length = 8): string => {
  let password = '';

  while (password.length < length) {
    const bytes = crypto.getRandomValues(new Uint8Array(length));

    for (const byte of bytes) {
      if (byte < UNBIASED_LIMIT && password.length < length) {
        password += ALPHABET[byte % ALPHABET.length];
      }
    }
  }

  return password;
};
